import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { VIRTUALLY_UNLIMITED_NUM_OF_TASKS_PER_USER } from '@/components/Billing/billing-service.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtuallyUnlimitedExplanationMenu',
  setup(__props) {

const EXAMPLE_NUM_OF_USERS = 100;
const numOfTasks = VIRTUALLY_UNLIMITED_NUM_OF_TASKS_PER_USER;
const numOfTasksInPool = computed(() => numOfTasks * EXAMPLE_NUM_OF_USERS);

return { __sfc: true,EXAMPLE_NUM_OF_USERS, numOfTasks, numOfTasksInPool }
}

})